import { theme } from '@noths/polaris-client-ribbons-base';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { spacing } = theme;

export const container = css`
  display: inline-block;
  position: relative;
`;

export const input = css`
  display: block;
  position: relative;
  flex-shrink: 0;
  appearance: none;
  width: ${spacing.xl}px;
  height: ${spacing.xl}px;
  margin: ${spacing.base}px;
  border-radius: 6px;
  border: solid 1px var(--neutral-black-70);
  transition: background-color 200ms;
  background-color: var(--neutral-white-base);
  cursor: pointer;

  &:checked {
    background-color: ${palette.deepPurpleBase};
    border: none;
  }

  &:disabled {
    cursor: default;
    border-color: var(--neutral-black-40);
  }

  &:disabled:checked {
    opacity: 50%;
  }
`;

export const checkmark = css`
  position: absolute;
  left: 8px;
  top: 8px;
  width: ${spacing.md}px;
  height: ${spacing.md}px;
  transform: scale(0);
  transition: transform 400ms;
`;

export const checkmarkChecked = css`
  transform: scale(1);
`;
